import { render, staticRenderFns } from "./investment.vue?vue&type=template&id=07af500d&scoped=true&"
import script from "./investment.vue?vue&type=script&lang=js&"
export * from "./investment.vue?vue&type=script&lang=js&"
import style0 from "./investment.vue?vue&type=style&index=0&id=07af500d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07af500d",
  null
  
)

export default component.exports